/* models/ranges/data_range */ function _(require, module, exports) {
    var tslib_1 = require(426) /* tslib */;
    var range_1 = require(194) /* ./range */;
    var p = require(18) /* ../../core/properties */;
    var DataRange = /** @class */ (function (_super) {
        tslib_1.__extends(DataRange, _super);
        function DataRange(attrs) {
            return _super.call(this, attrs) || this;
        }
        DataRange.initClass = function () {
            this.define({
                names: [p.Array, []],
                renderers: [p.Array, []],
            });
        };
        DataRange.__name__ = "DataRange";
        return DataRange;
    }(range_1.Range));
    exports.DataRange = DataRange;
    DataRange.initClass();
}
